import { render, staticRenderFns } from "./CartTable.vue?vue&type=template&id=1993f614&"
import script from "./CartTable.vue?vue&type=script&lang=ts&"
export * from "./CartTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports